<template>
  <header-page-layout page-title="Templates">
    <template slot="actions">
      <b-button :to="{ name: 'templates-create' }" variant="primary">Create Template</b-button>
    </template>

    <b-table
      hover
      stacked="md"
      :items="templates"
      :fields="fields"
      class="bg-white"
    >
      <template slot="name" slot-scope="data">
        <router-link :to="{ name: 'templates-edit', params: { id: data.item._id } }">{{data.item.name}}</router-link>
        <div><small class="text-small text-muted">{{data.item.description}}</small></div>
      </template>

      <template slot="active" slot-scope="data">
        <fa icon="check-circle" v-if="data.item.active"></fa>
      </template>
    </b-table>

    <b-row v-if="templates.length === 0">
      <b-col>
        <b-alert variant="info" show>No templates have been created yet</b-alert>
      </b-col>
    </b-row>

  </header-page-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'
import store from '../store'

export default {
  components: {
    HeaderPageLayout
  },

  data() {
    return {
      fields: [
        { key: 'name', thClass: ['w-75'] },
        { key: 'active', tdClass: ['text-nowrap'] }
      ]
    }
  },

  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch('templates/fetchAll')
    ])
      .then(() => next())
  },

  computed: {
    ...mapState('templates', [
      'templates'
    ])
  },

  methods: {
    ...mapActions('templates', [
      'fetchAll',
      'deleteTemplate'
    ]),

    remove(id) {
      if (confirm('Are you sure you want to delete this template?')) {
        this.deleteTemplate(id)
          .then(() => {
            return this.fetchAll()
          })
      }
    }

  }
}
</script>

<style scoped>
</style>
